import React, { useRef, useState } from "react";
import { api, fileUrl } from "../../lib/api";
import { UploadCloud, X, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ imageId, onChange, testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.id);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Kunne ikke laste opp bildet");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {imageId ? (
        <div className="relative inline-block">
          <img src={fileUrl(imageId)} alt="Opplastet" className="h-28 w-28 rounded-lg object-cover border border-hairline" />
          <button
            type="button"
            onClick={() => onChange(null)}
            className="absolute -top-2 -right-2 flex h-6 w-6 items-center justify-center rounded-full bg-navy text-white"
            data-testid={`${testid}-remove`}
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="flex w-full flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-hairline bg-white px-4 py-6 text-ink/60 hover:border-electric hover:text-electric transition-colors"
          data-testid={testid}
        >
          {uploading ? <Loader2 className="h-6 w-6 animate-spin" /> : <UploadCloud className="h-6 w-6" />}
          <span className="text-sm font-medium">{uploading ? "Laster opp ..." : "Last opp bilde (valgfritt)"}</span>
          <span className="flex items-center gap-1 text-xs"><ImageIcon className="h-3 w-3" /> JPG, PNG, WEBP · maks 8 MB</span>
        </button>
      )}
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`${testid}-input`} />
    </div>
  );
}
